import React, { useState, useEffect } from 'react'
import { Typography, Input, Row, Col, Button, Space, } from 'antd';
import { UserAddOutlined, SearchOutlined } from '@ant-design/icons';
import { Screen } from '../../components/UI/Screen.component';
import { Container } from '../../components/UI/Container.component';
import { ScreenHeader } from '../../components/UI/ScreenHeader.component';
import { Section } from '../../components/UI/Section.component';
import { UserTable } from '../../components/Dashboard/User/UserTable';
import { Modal } from '../../components/UI/Modal/Modal.component';
import UserService from '../../services/user.service';
import { AddNewUserForm } from '../../components/Dashboard/User/AddNewUserForm';
const { Title } = Typography;


export const UserScreen = () => {

    const [displayModal, setDisplayModal] = useState(false);
    const [search, setSearch] = useState('');

    const [dataSource, setDataSource] = useState([])
    const [isLoaded, setIsLoaded] = useState(false);
    const [change, setChange] = useState(false);

    const handleEnter = (e) => {
        if (e.key === 'Enter') {
            return false;
        }
    }

    useEffect(() => {
        let data = {filter: search}
        UserService.getUsers(data).then(
            (response) => {
                setDataSource(response.data.users)
                setIsLoaded(true)
            },
            (error) => {
                console.log(error.response)
            }
        );
    }, [search])
    


    const clearBtnDisplay = search === '' ? 'none' : 'block';

    return(
        <>
            <Screen id="access-screen">
                <Container>
                    <ScreenHeader>
                        <Title>Administración de Usuarios</Title>
                    </ScreenHeader>
                    <Section>
                        <Row justify="space-between" style={{marginBottom: "30px", gap:"30px",}}>
                            <Col>
                                <Space size="small">
                                    <p>Buscar:</p>
                                    <Input suffix={<SearchOutlined/>} placeholder="" allowClear value={search} onChange={(e) => setSearch(e.target.value)} />
                                    <Button type='primary' style={{display: clearBtnDisplay}} onKeyDown={(e) => handleEnter(e)} onClick={() => setSearch('')}>Borrar</Button> 
                                </Space>
                            </Col>
                            <Col>
                                <Button onClick={() => setDisplayModal(true)} type="primary" icon={<UserAddOutlined />}>Nuevo usuario</Button>
                            </Col>
                        </Row>
                        { isLoaded && <UserTable data={dataSource} search={search}/>}
                    </Section>
                </Container>
                <Modal title='Agregar nuevo usuario' visible={displayModal} setVisible={setDisplayModal} actionGroup={false}>
                    <AddNewUserForm setChange={setChange} setVisible={setDisplayModal} />
                </Modal>
            </Screen>
        </>
    )
}